$(document).on('change', '[name="empties_object"]', function() {
  const value = $('option:selected', this).val();
  if (value) {
    $('#empties_object_left').hide();
    $('#empties_object_reset').removeClass('hide');
    $('#empties_object_spacer').removeClass('hide');
    $('#id_object_name').attr('required', false);
    $('#id_address').attr('required', false);
    $('#id_zip').attr('required', false);
    $('#id_city').attr('required', false);
    $('#id_object_name').val(value);
    $('#id_address').val(value);
    $('#id_zip').val('1111');
    $('#id_city').val(value);
  } else {
    $('#empties_object_spacer').addClass('hide');
    $('#empties_object_left').show();
    $('#empties_object_reset').addClass('hide');
    $('#id_object_name').attr('required', true);
    $('#id_address').attr('required', true);
    $('#id_zip').attr('required', true);
    $('#id_city').attr('required', true);
    $('#id_object_name').val('');
    $('#id_address').val('');
    $('#id_zip').val('');
    $('#id_city').val('');
  }
});

$(document).on('click', '[id="reset-empties_object"]', function() {
  const itemid = $('option:selected', this).val();
  console.log(itemid);
  $('#empties_object_left').show();
  $('#empties_object_spacer').addClass('hide');
  $('#id_empties_object').prop('selectedIndex', 0);
  $('#id_empties_object').val();
  $('#empties_object_reset').addClass('hide');
  $('#id_object_name').attr('required', true);
  $('#id_address').attr('required', true);
  $('#id_zip').attr('required', true);
  $('#id_city').attr('required', true);
  $('#id_object_name').val('');
  $('#id_address').val('');
  $('#id_zip').val('');
  $('#id_city').val('');
});
